// extracted by mini-css-extract-plugin
module.exports = {"adContainer":"styles_adContainer__1qURK","imageWeb":"styles_imageWeb__F09UG","imageMobile":"styles_imageMobile__TE0el"};